import debug from 'debug';

export default debug('gcs-browser-upload');
